import { SET_ANALYTICS_TRACKING_ENABLED } from 'actions';

export function setAnalyticsTrackingEnabled(analyticsTrackingEnabled: boolean) {
  return {
    analyticsTrackingEnabled,
    type: SET_ANALYTICS_TRACKING_ENABLED,
  };
}
